import {Leads, Text, Trail, Typography} from '@yandex-delivery/blocks'
import React from 'react'
import type {
  LocalPaymentItem as LocalPaymentItemType,
  PaymentItem,
  PaymentItemType,
  RemotePaymentItem as RemotePaymentItemType,
} from 'src/api'
import {tagToUrl} from 'src/shared/utils'

import {TextItem} from '../text-item'
import {classes} from './Payment.styles'

type Props = {
  item: PaymentItem
}
type ItemComponent = React.ComponentType<Props>

const paymentItemMap: Record<PaymentItemType, ItemComponent> = {
  'local-payment-item': LocalPaymentItem as ItemComponent,
  'remote-payment-item': RemotePaymentItem as ItemComponent,
}

type LocalPaymentItemProps = {
  item: LocalPaymentItemType
}
function LocalPaymentItem({item}: LocalPaymentItemProps): React.ReactElement | null {
  const {price} = item

  if (!price) {
    return null
  }

  return (
    <Text>
      <Typography variant="body2">{item.price}</Typography>
    </Text>
  )
}

type RemotePaymentItemProps = {
  item: RemotePaymentItemType
}
function RemotePaymentItem({item}: RemotePaymentItemProps): React.ReactElement {
  const {title, lead_icon: leadIcon, subtitle, trail_title: trailTitle, trail_subtitle: trailSubtitle} = item
  return (
    <>
      {leadIcon && (
        <Leads.Icon>
          <img alt="" className={classes.icon} data-theme-invert loading="lazy" src={tagToUrl(leadIcon.image_tag)} />
        </Leads.Icon>
      )}
      <Text>
        <TextItem item={title} />
        {subtitle && <TextItem item={subtitle} />}
      </Text>
      {(trailTitle || trailSubtitle) && (
        <Trail>
          {trailTitle && <TextItem item={trailTitle} />}
          {trailSubtitle && <TextItem item={trailSubtitle} />}
        </Trail>
      )}
    </>
  )
}

export function PaymentItemComponent({item}: Props): React.ReactElement {
  const PaymentComponent: ItemComponent | null = paymentItemMap[item.type as PaymentItemType]

  return PaymentComponent && <PaymentComponent item={item} />
}

export default PaymentItemComponent
